import React from 'react';

export const LinkList = ({ children }) => (
  <div className="Links">
    <ul className="Links__List">{children}</ul>
  </div>
);

export const LinkListItem = ({
  href = null,
  type = 'file',
  children,
  ...props
}) => (
  <li className="Links__ListItem">
    <a
      href={href}
      data-link-type={type}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {children}
    </a>
  </li>
);
